import {Grid} from "@mui/system";

import pxToRem from "hooks/usePxToRem";

import {DefaultCardStructure} from "components";
import {Controller, useFormContext} from "react-hook-form";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";
import useOriginalOrAlternativeValue from "hooks/useOriginalOrAlternativeValue";

const Receipt = () => {
  const {control} = useFormContext();

  const {valueOrEmptyString} = useOriginalOrAlternativeValue();

  return (
    <DefaultCardStructure
      title="Recebimento"
      hasDivider={false}
      isSubcard={true}
      titleMarginBottom={12}
    >
      <Grid container rowSpacing={pxToRem(10)} columnSpacing={pxToRem(4)}>
        <Grid size={5}>
          <Controller
            name="charges.typeReceipt"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.typeReceipt"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Tipo Recebimento"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2}>
          <Controller
            name="charges.quantityReceipt"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.quantityReceipt"
                type="text"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Quantidade"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={5}>
          <Controller
            name="charges.receiveFrom"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.receiveFrom"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Receber de"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={12}>
          <Controller
            name="charges.receiptPerson"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.receiptPerson"
                type="text"
                value={valueOrEmptyString(value?.name)}
                onChange={onChange}
                size="small"
                disabled
                label="Pessoa"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2.4}>
          <Controller
            name="charges.receiptCurrency"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.receiptCurrency"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Moeda"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2.1}>
          <Controller
            name="charges.valueReceiptUnit"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.valueReceiptUnit"
                type="text"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Valor unitário"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2.1}>
          <Controller
            name="charges.valueReceiptMinimum"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.valueReceiptMinimum"
                type="text"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Valor mínimo"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2.1}>
          <Controller
            name="charges.valueReceiptTotal"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.valueReceiptTotal"
                type="text"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Valor total"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={3.3}>
          <Controller
            name="charges.modalityReceipt"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.modalityReceipt"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Modalidade"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={4.5}>
          <Controller
            name="charges.billingReceipt"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.billingReceipt"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Faturamento"
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
    </DefaultCardStructure>
  );
};

export default Receipt;
